var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Collapse, TableCell, TableRow, Typography, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { GetSelectedOrderDetailsAPI } from '../../../api/oms/order-details';
import { GetDeliveryTrackerInfo } from '../../../hooks/delivery-tracker-hooks';
import { useCommonContext, useExperienceContext, usePurchaseHistoryContext, } from '../../../hooks/useContexts';
import { PRINT_LABEL_MINIMUM_VERSION } from '../../../constants/returns';
import { getWindow } from '../../../utils/general';
import { checkTHDConsumerVersion, getMobileOSAndVersion, } from '../../../utils/shared/mobile';
import { generateOrderDetailsRequest, sliceLongText } from '../util/tableUtils';
import { ExpandedTableRow } from './index';
import { orderNumberParams, retrieveLineItems } from '../util/shared';
import { retrieveSelectedOrderDetail } from '../../../utils/purchase-history/helpers';
import { PHTableData } from './PHTableData';
import { PHTableMenu } from './PHTableMenu';
export var PHTableRow = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var order = _a.order, index = _a.index, selected = _a.selected, setSelected = _a.setSelected, setAlertState = _a.setAlertState, customerType = _a.customerType, orderHistoryData = _a.orderHistoryData, isAdminRole = _a.isAdminRole, searchEnabled = _a.searchEnabled, pHRequest = _a.pHRequest, tableHeaderState = _a.tableHeaderState, fetchOrderDetailsAfterSearch = _a.fetchOrderDetailsAfterSearch;
    var _v = usePurchaseHistoryContext(), allOrderDetails = _v.allOrderDetails, setAllOrderDetails = _v.setAllOrderDetails, cpsDataSource = _v.cpsDataSource;
    var _w = useExperienceContext(), isConsumerApp = _w.isConsumerApp, channel = _w.channel;
    var rowRef = useRef(null);
    var _x = useState(null), orderDetailsError = _x[0], setOrderDetailsError = _x[1];
    var _y = useState(false), orderDetailsLoaded = _y[0], setOrderDetailsLoaded = _y[1];
    var _z = useState(false), isLoadingOrderDetails = _z[0], setIsLoadingOrderDetails = _z[1];
    var svocID = useThdCustomer().svocID;
    var timezone = useCommonContext().timezone;
    var selectedOrderDetail = retrieveSelectedOrderDetail(order, allOrderDetails, customerType, cpsDataSource);
    useEffect(function () {
        if (selectedOrderDetail) {
            setOrderDetailsLoaded(true);
        }
        if (searchEnabled === false || fetchOrderDetailsAfterSearch) {
            var observer_1 = new IntersectionObserver(function (_a) {
                var entry = _a[0];
                if (entry.isIntersecting &&
                    orderDetailsLoaded === false &&
                    !selectedOrderDetail &&
                    !isLoadingOrderDetails) {
                    setIsLoadingOrderDetails(true);
                    GetSelectedOrderDetailsAPI(generateOrderDetailsRequest(order, customerType, svocID, timezone), channel)
                        .then(function (response) {
                        GetDeliveryTrackerInfo(response.data).then(function (deliveryTrackingData) {
                            setAllOrderDetails(function (prevDetails) {
                                return deliveryTrackingData
                                    ? __spreadArray(__spreadArray([], prevDetails, true), [
                                        deliveryTrackingData,
                                    ], false) : prevDetails;
                            });
                        });
                    })
                        .catch(function (error) {
                        setOrderDetailsError(error);
                    })
                        .finally(function () {
                        setOrderDetailsLoaded(true);
                        setIsLoadingOrderDetails(false);
                    });
                }
            }, { root: null, rootMargin: '0px', threshold: 0.1 });
            if (rowRef.current) {
                observer_1.observe(rowRef.current);
            }
            return function () {
                if (rowRef.current) {
                    observer_1.unobserve(rowRef.current);
                }
            };
        }
        return function () { return null; };
    }, [selectedOrderDetail, orderDetailsLoaded, isLoadingOrderDetails]);
    var handleRowClick = function (id) {
        setSelected(function (prevSelected) {
            var _a;
            return __assign(__assign({}, prevSelected), (_a = {}, _a[id] = selected[id] === id ? null : id, _a));
        });
    };
    var orderParams = {
        orderNumbers: orderNumberParams(order),
        salesDate: (_b = order.salesDate) !== null && _b !== void 0 ? _b : '',
        storeNumber: (_c = order.storeNumber) !== null && _c !== void 0 ? _c : 0,
        transactionId: (_d = order.transactionId) !== null && _d !== void 0 ? _d : 0,
        orderOrigin: (_f = (_e = order === null || order === void 0 ? void 0 : order.orderOrigin) !== null && _e !== void 0 ? _e : order === null || order === void 0 ? void 0 : order.detailsSource) !== null && _f !== void 0 ? _f : '',
        registerNumber: (_g = order.registerNumber) !== null && _g !== void 0 ? _g : 0,
        transactionType: (_h = order.transactionType) !== null && _h !== void 0 ? _h : '',
        index: index,
        nickName: (_j = order === null || order === void 0 ? void 0 : order.nickName) !== null && _j !== void 0 ? _j : '',
    };
    var allLineItemImages = retrieveLineItems(selectedOrderDetail);
    var isB2BOnlineOrder = customerType === 'b2b' && ((_k = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _k === void 0 ? void 0 : _k[0]) === 'W';
    var allowNativeAppInStoreReceiptPrint = ((_l = getWindow()) === null || _l === void 0 ? void 0 : _l.__EXPERIENCE_PROPS__.expConfiguration.allowNativeAppInStoreReceiptPrint) === 'true' || false;
    var appInfo = getMobileOSAndVersion();
    var isSufficientVersion = checkTHDConsumerVersion(appInfo.version, PRINT_LABEL_MINIMUM_VERSION[appInfo.os]);
    var showViewReciptLink = (allowNativeAppInStoreReceiptPrint && isSufficientVersion) ||
        !isConsumerApp;
    var formatOrderOrigin = function (text) {
        var tempText = text.split(',');
        return (React.createElement("div", { className: "sui-text-base" },
            React.createElement(Typography, null, tempText === null || tempText === void 0 ? void 0 : tempText[0]),
            (tempText === null || tempText === void 0 ? void 0 : tempText[1]) && (React.createElement(Typography, null, sliceLongText(tempText === null || tempText === void 0 ? void 0 : tempText[1], 12)))));
    };
    var searchByObj = (_o = (_m = pHRequest === null || pHRequest === void 0 ? void 0 : pHRequest.searchBy) === null || _m === void 0 ? void 0 : _m[0]) !== null && _o !== void 0 ? _o : {};
    var tableData = PHTableData(allLineItemImages, formatOrderOrigin, handleRowClick, index, isAdminRole, order, orderDetailsLoaded, orderParams, searchByObj, searchEnabled, selected, setAlertState, tableHeaderState, selectedOrderDetail, orderDetailsError);
    var emptyHeaders = [];
    return (React.createElement(Fragment, { key: index },
        React.createElement(TableRow, { ref: rowRef, lastVisible: index === orderHistoryData.length, style: { height: '68px' } }, tableData === null || tableData === void 0 ? void 0 :
            tableData.map(function (item, indexJ) {
                if ((item === null || item === void 0 ? void 0 : item.showTableData) === false) {
                    emptyHeaders.push(item);
                    return null;
                }
                if ((item === null || item === void 0 ? void 0 : item.isAdmin) === false) {
                    return (React.createElement(TableCell, { key: indexJ, variant: "body", padding: "none", style: item === null || item === void 0 ? void 0 : item.style },
                        React.createElement("div", null)));
                }
                if ((item === null || item === void 0 ? void 0 : item.align) === 'center') {
                    return (React.createElement(TableCell, { key: indexJ, style: item === null || item === void 0 ? void 0 : item.style, valign: item === null || item === void 0 ? void 0 : item.verticalAlign, align: item === null || item === void 0 ? void 0 : item.align }, item === null || item === void 0 ? void 0 : item.content));
                }
                return (React.createElement(TableCell, { key: indexJ, variant: "body", padding: "none", style: item === null || item === void 0 ? void 0 : item.style }, item === null || item === void 0 ? void 0 : item.content));
            }), emptyHeaders === null || emptyHeaders === void 0 ? void 0 :
            emptyHeaders.map(function (item, indexK) {
                if (indexK < 3) {
                    return null;
                }
                return (React.createElement(TableCell, { key: indexK, variant: "body", padding: "none", style: item === null || item === void 0 ? void 0 : item.style },
                    React.createElement("div", null)));
            }),
            React.createElement(TableCell, { variant: "body", padding: "none", style: { maxWidth: '36px' } },
                React.createElement(PHTableMenu, { customerType: customerType, enableReceipt: !(selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.isAAFESOrder) &&
                        !(selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.isNEXOrder) &&
                        !isB2BOnlineOrder &&
                        ((selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.showReceiptImage) ||
                            Boolean(selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.receiptImageSting)) &&
                        showViewReciptLink, encryptedReceiptRequest: (_p = order === null || order === void 0 ? void 0 : order.encryptedReceiptRequest) !== null && _p !== void 0 ? _p : '', orderDetailsData: selectedOrderDetail, orderNumber: (_s = (_q = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _q !== void 0 ? _q : (_r = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _r === void 0 ? void 0 : _r[0]) !== null && _s !== void 0 ? _s : '', orderOrigin: (_t = order.orderOrigin) !== null && _t !== void 0 ? _t : '', orderParams: orderParams, receiptImageSting: (_u = selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.receiptImageSting) !== null && _u !== void 0 ? _u : '', setAlertState: setAlertState }))),
        React.createElement(TableRow, { collapsed: selected[index] !== index },
            React.createElement(TableCell, { colSpan: 12, style: {
                    padding: !searchEnabled ? '10px 40px 10px 45px' : '0px',
                }, padding: "none" },
                React.createElement(Collapse, { in: selected[index] === index }, !searchEnabled && (React.createElement(ExpandedTableRow, { orderDetailsData: selectedOrderDetail, orderDetailsError: orderDetailsError, orderDetailsLoaded: orderDetailsLoaded })))))));
};
